import { pathBuilder } from 'config/paths/index';

export const root = '/admin/forms';
export default pathBuilder(root);
